import routes from '@/router/index'
import Vue from 'vue'


/**
 * 工具方法
 * 拷贝对象
 * tag中属性值为Undefined 拷贝src的值
 */
let copyObject = function (tag, ...src) {
  return _.assignWith(tag, ...src, (objValue, srcValue, key, tagObj, srcObj) => {
    return _.isUndefined(srcValue) ? objValue : srcValue;
  });
};
/**
 *继承工具方法
 */
let extendFun = (function () {
  let extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf ||
      ({
          __proto__: []
        }
        instanceof Array && function (d, b) {
          d.__proto__ = b;
        }) ||
      function (d, b) {
        for (let p in b)
          if (b.hasOwnProperty(p)) d[p] = b[p];
      };
    return extendStatics(d, b);
  }
  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    return d;
  };
})();

/**
 *继承工具方法
 */



/**
 * 获取路由组件工具方法
 */

let useComponent = function (namespaces, callback) {
  assemblyComponent(namespaces).then(value => {
    callback(value.default);
  })

}

/**
 * 通过路由路径 得到组件的Promise 方法
 * @param namespace  'componentNamspace,componentName'
 * @returns {*}
 // 找到传入的routes路径
 */
function assemblyComponent(namespace) { //一个参数路径[]
  // let example = routes.options.routes;
  let example = routerSearch(routes.options.routes, namespace)


  return example.component();
}
// 递归查询路由
function routerSearch(arr, str) {
  // return arr[0].children[1]
  if (str == 'component-dialog') {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].name == str) {
        return arr[i]
      }
    }
  } else {
    for (let k = 0; k < arr[0].children.length; k++) {
      if (arr[0].children[k].name == str) {
        return arr[0].children[k]
      }
    }
  }
  // for (let i = 0; i < arr.length; i++) {
  //   if (arr[i].name == str) {
  //     return arr[i]
  //   } else if (arr[i].children && arr[i].children.length) {
  //     routerSearch(arr[i].children, str)
  //   }
  // }


}




/**
 * 递归获取对象属性 例'xx.yy.zz'形式
 * @param obj
 * @param prop
 * @returns {*}
 */
function fetchFromObject(obj, prop) {

  if (obj == null) {
    return null;
  }

  let _index = prop.indexOf('.')
  if (_index > -1) {
    return fetchFromObject(obj[prop.substring(0, _index)], prop.substr(_index + 1));
  }

  return obj[prop];
}






let utils = {
  extendFun,
  useComponent,
  fetchFromObject,
  copyObject
};

//注入全局变量
Vue.prototype.$utils = utils;
export default utils